import { createContext } from 'react';
import { IFbClient } from '@featbit/js-client-sdk';

import { IFlagSet } from './types';

interface FeatbitContext {
  flags: IFlagSet;
  fbClient?: IFbClient;
  error?: Error;
}

const context = createContext<FeatbitContext>({ flags: {}, fbClient: undefined });

const { Provider, Consumer } = context;

export { Consumer as FeatbitConsumer, FeatbitContext, Provider as FeatbitProvider };
export default context;
